// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { xIsAuthenticated } from "@werner/App/Store/Selectors/GeneralSelectors";
import { SalesPerson } from "@werner/App/Store/Types/SalesPerson";

export const getCustomTypeSession = (state: ApplicationState) => {
    return getSession(state);
};

type HasUserRolesRredicate = "one-or-more" | "apply-all" | "none";

export const xHasRoles = (
    state: ApplicationState,
    roles: string[],
    predicate: HasUserRolesRredicate = "one-or-more",
) => {
    const isAuthenticated = xIsAuthenticated(state);
    if (!isAuthenticated) {
        return false;
    }

    const session = getSession(state);
    const userRoles = session.userRoles.trim().split(",");

    if (predicate === "one-or-more") {
        return userRoles.some(role => roles.includes(role.trim()));
    }

    if (predicate === "apply-all") {
        return userRoles.every(role => roles.includes(role.trim()));
    }

    if (predicate === "none") {
        return userRoles.every(role => !roles.includes(role.trim()));
    }
};

export const getSalesPersonByType = (state: ApplicationState, type: "inside" | "outside"): SalesPerson | undefined => {
    const key = type === "inside" ? "insideSalesPerson" : "outsideSalesPerson";
    const salesPersonAsString = getSession(state).properties[key];
    if (!salesPersonAsString) {
        return;
    }

    const data: SalesPerson = JSON.parse(getSession(state).properties[key]);
    return data;
};
